<div id="content">
	<section id="main" class="bg-light">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h1 [innerHtml]="'CERT_5' | translator:'base'">Terms and conditions
					</h1>
					<div class="row">
						<div class="col-12">
							<div id="eulaForm">
								<!-- Legal language -->
								<div class="alert alert-danger">
									<h2 class="mb-0" [innerHTML]="'GovernmentWarning' | translator:'base'">
										ATTENTION ATTENTION ATTENTION</h2>
								</div>
								<p [innerHTML]="'UnauthAccesIllegalTitleText' | translator:'base'">
									You are accessing a U.S. Government information system, which includes (1)
									this computer, (2) this computer network, (3) all computers connected to
									this network, and (4) all devices and storage media attached to this
									network or to a computer on this network. This information system is
									provided for U.S. Government-authorized use only.
								</p>
								<p [innerHTML]="'UnauthorizedTitleText' | translator:'base'">
									Unauthorized or improper use of this system may result in disciplinary
									action, as well as civil and criminal penalties.
								</p>
								<p [innerHTML]="'ContainsProtectedInfoTitleText' | translator:'base'">
									This system contains information protected under the provisions of the
									Privacy Act of 1974 (Public Law 93-579). Any privacy information displayed
									on the screen or printed shall be protected from unauthorized disclosure.
									Individuals who violate privacy safeguards may be subject to disciplinary
									actions, a fine of up to $5,000, or both.
								</p>
								<p [innerHTML]="'NoReasonable' | translator:'base'">
									By using this information system, you understand and consent to the
									following:<br />
									You have no reasonable expectation of privacy regarding any communications
									or data transiting or stored on this information system. At any time, and
									for any lawful government purpose, the government may monitor, intercept,
									and search and seize any communication or data transiting or stored on this
									information system.
								</p>
								<p [innerHTML]="'AnnyComm' | translator:'base'">
									Any communications or data transiting or stored on this
									information system may be disclosed or used for any lawful
									government purpose.
								</p>
								<div class="" [formGroup]="agreeInitials">
									<label for="initials" class="form-label"><span
											[innerHtml]="'InitialsRequired' | translator:'base'">Requestor's
											Initials (Required to proceed)</span><span
											class="text-danger text-center ms-1"
											[title]="'Required' | translator:'base'">*</span></label>
									<input [title]="'InitialsRequiredTitle' | translator:'base'"
										class="form-control w-auto" type="text" id="initials" name="initials"
										size="3" tabindex="1" maxlength="3" formControlName="initials" />
									<div *ngIf="initials!.invalid && initials!.dirty"
										class="help-block text-danger">
										<div *ngIf="initials!.errors?.['required']"
											[innerHtml]="'FieldRequired' | translator:'base'">
										</div>
										<div *ngIf="initials!.hasError('minlength') && !initials!.errors?.['pattern'] "
											[innerHtml]="'InitialsLength' | translator:'base'">
										</div>
										<div *ngIf="initials!.errors?.['pattern'] && !initials!.errors?.['required']"
											[innerHtml]="'AlphaOnly' | translator:'base'">
										</div>
									</div>
								</div>
							</div>
							<!-- Buttons -->
							<div class="mt-3">
								<button id="btnAgree" name="btnAgree" (click)="onBtnAgreeClick()"
									class="btn btn-primary btn-strong me-2 mb-2" tabindex="1"
									[title]="'IAgree' | translator:'base'"
									[disabled]="(!initials!.dirty || initials!.errors || !userProfileLoaded ? 'true': null)">
									<span [innerHtml]="'IAgree' | translator:'base'">I Agree</span>
								</button>
								<button (click)="onBtnDisagreeClick()" class="btn btn-outline-primary mb-2"
									tabindex="1" [title]="'DoNotAgreeToTerms' | translator:'base'"
									name="DoNotAgreeToTerms" id="DoNotAgreeToTerms"
									[disabled]="(!userProfileLoaded)">
									<span [innerHtml]="'DoNotAgreeToTerms' | translator:'base'">Do Not Agree to
										Terms</span>
								</button>
							</div>
						</div>
					</div>
				</div>

				<ng-template #AttestationModal let-modal>
					<div class="modal-header">
						<h3 id="attestationModalTitle" class="modal-title" slot="header"
							[innerHtml]="'eula_attestation_modal_header' | translator:'base'">
							Mandatory Driver Disclosure and Authorization Language Confirmation
						</h3>
					</div>
					<div class="modal-body">
						<p>
							<span [innerHtml]="'eula_attestation_modal_1' | translator: 'base'">
								I acknowledge that my company has implemented and uses the
								FMCSA-mandated driver disclosure and authorization form. My company
								requires that every driver sign the
							</span>
							<a target="_blank"
								[href]="updateUrl('##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf')"
								[title]="'DnA_link_title' | translator:'base'"
								[innerHtml]="'eula_attestation_modal_2b' | translator: 'base'" id="dna"
								name="dna">
								FMCSA-mandated driver disclosure and authorization form
							</a>
							<span [innerHtml]="'eula_attestation_modal_3' | translator: 'base'">
								before his or her PSP report is requested.
							</span>
						</p>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary ms-2" (click)="agreeToAttestation()"
							[title]="'accept_button' | translator:'base'" name="Accept" id="Accept">
							<span [innerHtml]="'accept_button' | translator:'base'">Accept</span>&nbsp;
						</button>
						<button class="btn btn-outline-primary" (click)="disagreeToAttestation()"
							[title]="'decline_button' | translator:'base'" name="Decline" id="Decline">
							<span [innerHtml]="'decline_button' | translator:'base'">Decline</span>&nbsp;
						</button>
					</div>
				</ng-template>

				<ng-template #LanguageChangeModal let-modal>
					<div class="modal-header">
						<h3 id="languageChangeModalTitle" class="modal-title"
							[innerHtml]="'eula_language_change_modal_header' | translator:'base'">
							MANDATORY DRIVER DISCLOSURE AND AUTHORIZATION CHANGES - ACT TODAY!
						</h3>
					</div>
					<div class="modal-body">
						<p>
							<span [innerHtml]="'eula_language_change_modal_1' | translator:'base'">
								FMCSA has updated the form that you must use to disclose to a
								driver that you are accessing their PSP record and to gain that
								driver's authorization. Review the new
							</span>
							<a target="_blank"
								[href]="updateUrl('##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf')"
								[title]="'DnA_link_title' | translator:'base'" id="dnaLink" name="dnaLink">
								<span [innerHtml]="'DnA_link_text' | translator:'base'">
									driver disclosure and authorization form
								</span>
							</a>
							<span [innerHtml]="'eula_language_change_modal_3' | translator:'base'">
								to make sure your company is in compliance. Your company MUST use this form
								going forward.
							</span>
						</p>
						<div class="form-check">
							<label class="form-check-label">
								<input type="checkbox" [(ngModel)]="shouldSendFormViaEmail" tabindex="1"
									[title]="'eula_send_email' | translator:'base'" id="sendForm"
									name="sendForm" class="form-check-input" />
								<span [innerHtml]="'eula_send_email' | translator:'base'"
									[title]="'eula_send_email' | translator:'base'">Check here to receive the
									new form in an email.</span>
							</label>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary ms-2" (click)="submitEula()"
							[title]="'accept_button' | translator:'base'" name="btnAccept" id="btnAccept">
							<span [innerHtml]="'accept_button' | translator:'base'">Accept</span>
						</button>
					</div>
				</ng-template>

				<ng-template #WarningDialog let-modal>
					<div class="modal-header">
						<h3 id="warningDialogTitle" class="modal-title" name="warningModalTitle"
							[innerHtml]="'eula_warning_modal_header' | translator:'base'">
							WARNING
						</h3>
					</div>
					<div class="modal-body">
						<p class="bold">
							<span [innerHtml]="'eula_warning_modal_1' | translator:'base'">You did NOT confirm
								that your company is using the</span>
							<a target="_blank"
								[href]="updateUrl('##docBaseUrl##/PSPDisclosureandAuthorizationForm.pdf')"
								[title]="'DnA_link_title' | translator:'base'" id="dnaForm2" name="dnaForm2">
								<span [innerHtml]="'DnA_link_text_driver' | translator:'base'">
									FMCSA-required disclosure and authorization form
								</span>
							</a>.
						</p>
						<p [innerHtml]="'eula_warning_modal_2' | translator:'base'" class="bold">
							This language is mandatory for all PSP account holders. In the
							event of a PSP audit, failure to use the mandatory disclosure and
							authorization form will result in penalties including warnings and
							suspension or termination from the PSP service. Audits occur on a
							monthly basis.
						</p>
						<p>
							<span [innerHtml]="'eula_warning_modal_3a' | translator:'base'">
								Please review the mandatory disclosure and authorization form, and
								coordinate with your company's primary account contact to ensure all
								users, at all locations, are using this language to obtain
								authorization. For more information, take a look at our
							</span>
							<a target="_blank" [href]="updateUrl('##docBaseUrl##/PSP_AUDIT.pdf')"
								[title]="'eula_warning_modal_3b_title' | translator:'base'" id="auditCompliance"
								name="auditCompliance">
								<span [innerHtml]="'eula_warning_modal_3b_text' | translator:'base'">one-page
									audit guide</span>
							</a>
							<span [innerHtml]="'eula_warning_modal_3c' | translator:'base'"> or contact customer
								service.</span>
						</p>
						<p [innerHtml]="'eula_warning_modal_3d' | translator:'base'">
							The PSP customer service team is available Monday through Thursday from 8 AM to 6 PM
							ET, and on Friday from 8 AM to 5 PM ET. To chat with an online representative, click
							the \"LIVE HELP\" button in the top-right corner of this page.
							You can also email us at <a href="mailto:PSPhelp@tylertech.com"
								title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a> or call us toll-free at
							1-877-642-9499.
						</p>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary ms-2" (click)="closeWarningDialog()"
							[title]="'eula_warning_modal_ok' | translator:'base'" name="closeWarning"
							id="closeWarning">
							<span [innerHtml]="'eula_warning_modal_ok' | translator:'base'">Ok</span>
						</button>
					</div>
				</ng-template>

				<div class="overlay" *ngIf="!userProfileLoaded">
					<h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading</h1>
					<img />
				</div>
				<div class="overlay" *ngIf="savingStatus">
					<h1 class="heading" [innerHtml]="'savingResponse' | translator:'base'">
						Saving response
					</h1>
					<img />
				</div>
			</div>

		</div>
	</section>
</div>